import React, { useState, useEffect, useContext, Context } from "react";
import * as msal from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import { UserAndClaims } from "./auth/getUserAndClaims";
import getActiveSessionData from "./auth/getActiveSessionData";

const hostedPages = process.env?.REACT_APP_AAD_HOSTED_PAGES || "";
const appUrl = process.env?.REACT_APP_URL || "";
let pc: msal.PublicClientApplication;
export let acquireToken: Function;
export let credential: () => TokenResponse | undefined;
export let account: () => msal.AccountInfo;
export let requestLogin: (loginRequest: msal.RedirectRequest, method: any) => Promise<void>;
export type TokenResponse = {
  accessToken?: string;
  idToken?: string;
};
export type TokenRequest = (request: msal.SilentRequest, method?: any) => Promise<any>;
export type AuthContext = {
  isAuthenticated: boolean;
  user: msal.AccountInfo;
  claims?: DUClaims;
  token: TokenResponse | undefined;
  loading: boolean;
  login: Function;
  logout: Function;
  getToken: TokenRequest;
};
export type DUClaims = {
  acr: string;
  at_hash: string;
  aud: string;
  auth_time: number;
  email: string;
  exp: number;
  extension_requiresMigration: boolean;
  family_name: string;
  given_name: string;
  iat: number;
  iss: string;
  nbf: number;
  nonce: string;
  sub: string;
  tid: string;
  ver: string;
};
const initialState: AuthContext = {
  isAuthenticated: false,
  user: {
    homeAccountId: "",
    environment: "",
    tenantId: "",
    username: "",
    name: "Volunteer",
    localAccountId: "",
  },
  claims: undefined,
  token: undefined,
  loading: false,
  login: () => null,
  logout: () => null,
  getToken: (request: msal.SilentRequest, method: any) => Promise.resolve("test"),
};
export const MsalContext: Context<AuthContext> = React.createContext(initialState);
export const useMsal = () => useContext(MsalContext);
export const MsalProvider = ({ children, config }: { children: any; config: msal.Configuration }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser]: [msal.AccountInfo, Function] = useState(initialState.user);
  const [claims, setClaims]: [DUClaims | undefined, Function] = useState();
  const [token, setToken]: [TokenResponse | undefined, Function] = useState();
  const [loading, setLoading] = useState(true);

  credential = () => token;
  account = () => user;
  useEffect(() => {
    pc = new msal.PublicClientApplication(config);
    (async () => {
      try {
        await pc.handleRedirectPromise();
        const { user: claimsUser, token: claimsToken, claims: newClaims, error }: UserAndClaims = await getActiveSessionData(pc, loginRequest);
        setIsAuthenticated(true);
        setToken(claimsToken);
        setUser(claimsUser);
        setClaims(newClaims);
        setIsAuthenticated(true);
        if (error) {
          throw error;
        }
      } catch (err: any) {
        const error = err?.message ? err.message : err?.error?.errorCode;
        console.info("getActiveSessionData", error);
      } finally {
        setLoading(false);
      }
    })();

    // eslint-disable-next-line
  }, []);
  const login = async (requestArgs: msal.PopupRequest) => {
    const extraParams = JSON.stringify({
      forgotPasswordUrl: `${hostedPages}/password?origin=${appUrl}`,
    });
    const request = {
      ...requestArgs,
      extraQueryParameters: { config: btoa(extraParams) },
    };
    pc?.loginRedirect(request);
  };
  requestLogin = login;

  const logout = () => {
    pc?.logoutRedirect();
  };

  const getToken = async (request: msal.SilentRequest, method: any) => {
    if (pc) {
      try {
        const { token: claimsToken, user: refreshedUser }: UserAndClaims = await getActiveSessionData(pc, request);
        setToken(claimsToken);
        setUser(refreshedUser);
        return claimsToken;
      } catch (err: any) {
        console.error(err.message);
      }
    }
    return { accessToken: "", idToken: "" };
  };
  acquireToken = getToken;

  return (
    <MsalContext.Provider
      value={{
        isAuthenticated,
        user,
        claims,
        token,
        loading,
        login,
        logout,
        getToken,
      }}
    >
      {children}
    </MsalContext.Provider>
  );
};
